import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

// eslint-disable-next-line max-len
const HealthSurveillanceIonisingRadiationSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.IonisingRadiation}
        >
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.TreatmentSinceLastOhMedicalExamination),
                    getQuestionConfig(props.questionConfigs, questionIds.TreatmentSinceLastOhMedicalExaminationFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.AbsentLast12MonthsThroughIllness),
                    getQuestionConfig(props.questionConfigs, questionIds.AbsentLast12MonthsThroughIllnessFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.RashesInLast12Months),
                    getQuestionConfig(props.questionConfigs, questionIds.RashesInLast12MonthsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.AnyOverCounterMedicationMoreThanOnce),
                    getQuestionConfig(props.questionConfigs, questionIds.AnyOverCounterMedicationMoreThanOnceFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.UseRespiratoryProtectiveEquipment),
                    getQuestionConfig(props.questionConfigs, questionIds.UseRespiratoryProtectiveEquipmentFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.IncurredHigherRadiationDose),
                    getQuestionConfig(props.questionConfigs, questionIds.IncurredHigherRadiationDoseFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.WorkWithRatiationChangedLast12Months),
                    getQuestionConfig(props.questionConfigs, questionIds.WorkWithRatiationChangedLast12MonthsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ExposureCarcinogenicAgents),
                    getQuestionConfig(props.questionConfigs, questionIds.ExposureCarcinogenicAgentsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadSpecialXRaysScansRadioTherapy),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadSpecialXRaysScansRadioTherapyFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.FeelsTheNeedForMedicalExamination),
                    getQuestionConfig(props.questionConfigs, questionIds.FeelsTheNeedForMedicalExaminationFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceIonisingRadiationSection = connect(makeMapStateToQuestionnaireSectionProps(sections.IonisingRadiation.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceIonisingRadiationSectionUnconnected);
